import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const ReservationListExtraItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    $("#checkins-panel-" + key).toggleClass("active");
    $("#reservations-item-" + key).toggleClass("toggled");
    searchParams.set("item", key);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        order={props.order}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        extra2={true}
        toggleElement={toggleElement}
        orderReservation={false}
        multipleCheckins={true}
        hasCompletedCheckouts={props.hasCompletedCheckouts}
        hasFutureCheckout={props.hasFutureCheckout}
        hasFutureCheckin={props.hasFutureCheckin}
        hasValidCheckin={props.hasValidCheckin}
        reservation={props.reservation}
        _exchangeLabel={props._exchangeLabel}
        setCheckout={props.setCheckout}
        dispatch={props.dispatch}
        checkout={props.checkout}
        app_user_role={props.app_user_role}
        setId={true}
        setCheckoutReservation={props.setCheckoutReservation}
        setCheckoutCheckin={props.setCheckoutCheckin}
        setFilter={props.setFilter}
        filter={props.filter}
        setNKey={props.setNKey}
        sort={props.sort}
        setSort={props.setSort}
        info={props.info}
      />
    </>
  );
};

export default ReservationListExtraItem;
